import { render, staticRenderFns } from "./PurchaseLayout.vue?vue&type=template&id=fe3db2b4"
import script from "./PurchaseLayout.vue?vue&type=script&lang=js"
export * from "./PurchaseLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports